export default __webpack_public_path__ + "static/487-13506aa4bc65c60612efeeb8d0ca8cc9.gif";